import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;
const B_URL = process.env.REACT_APP_LOGINURL


const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}


const getAll = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  return axios.post(API_URL, payload, { headers });
};

const getInvoices = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  //iph todo: 47
  //console.log("getInvoices", getInvoices)
  return axios.post(B_URL + 'Request_E_InvoiceModule/' + payload.functionName, payload, { headers });
};


const getUserInvoices = (payload) => {
  return axios.post(B_URL + 'OrderModule/getUserInvoices', payload, { headers });
};

const Get_User_Invoices = (page, limit, business, user_id) => {
  var payload = {
    functionName: "Get_User_Invoices",
    postData: {
      filter: {},
      limit: limit,
      offset: page,
      user_id: user_id,
      business: business
    }
  }
  //iph todo: 47
  //console.log("Get_User_Invoices", payload);
  return axios.post(B_URL + "E_invoiceFetchingModule/" + payload.functionName, payload, { headers });
};



const getAllStatements = (page, limit, filter) => {
  var payload = {
    functionName: "User_Record_Dashboard",
    Customer_ID: filter,
    limit: limit,
    offset: page
  }
  return axios.post(B_URL + "statements", payload, { headers });
};

const getAllBusiness = () => {
  var payload = {
    functionName: "GetBusinesses",
    postData: {
      limit: 9999999,
      offset: 0,
      business_ids: []
    }
  }
  return axios.post(B_URL + "BusinessModule/GetBusinesses", payload, { headers });
};

const getAllCategories = (page, limit, business_id) => {
  var payload = {
    functionName: "GetCategories",
    postData: {
      limit: limit,
      offset: page,
      business_id: business_id
    }
  }
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "CategoryModule/GetCategories", payload, { headers });
};

const GetRFQCategories = (page, limit, business_id) => {
  var payload = {
    functionName: "GetRFQCategories",
    postData: {
      limit: limit,
      offset: page,
      business_id: business_id
    }
  }
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "CategoryModule/GetRFQCategories", payload, { headers });
};


const getAllProducts = (page, limit, Category, Branch) => {
  var payload = {
    functionName: "GetCustomerItems",
    postData: {
      filter: {},
      portal: 'doctors',
      limit: limit,
      offset: page,
      category: Category,
      business: Branch
    }
  }
  //iph todo: 47
  //console.log("GetCustomerItems", payload);
  return axios.post(B_URL + "ItemsRoutes/GetCustomerItems", payload, { headers });
};



const GetDashboardData = (payload, sessionID) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'DashboardRoutes/GetDashboardData', payload, { headers });
};

const setCart = (payload) => {
  //iph todo: 47
  //console.log("setCart", payload);
  return axios.post(B_URL + "CartModule/setCart", payload, { headers });
};
const GetCartList = (payload) => {
  //iph todo: 47
  //console.log("GetCartList", payload);
  return axios.post(B_URL + "CartModule/GetCartList", payload, { headers });
};

const GetProducctDetails = (payload) => {
  //iph todo: 47
  //console.log("GetProducctDetails", payload);
  return axios.post(B_URL + "ItemModule/SearchItem", payload, { headers });
};

const GeProductReviews = (payload) => {
  //iph todo: 47
  //console.log("GeProductReviews", payload);
  return axios.post(B_URL + "OrderModule/ProductReviews", payload, { headers });
};

const DeleteCart = (payload) => {
  //iph todo: 47
  //console.log("DeleteCart", payload);
  return axios.post(B_URL + "CartModule/DeleteCart", payload, { headers });
};

const PlaceOrder = (payload) => {
  //iph todo: 47
  //console.log("PlaceOrder", payload);
  return axios.post(B_URL + "CartModule/PlaceOrder", payload, { headers });
};

const AddTopUp = (payload) => {
  //iph todo: 47
  //console.log("AddTopUp", payload);
  return axios.post(B_URL + "TopUpModule/AddTopUp", payload, { headers });
};

const GetTopUp = (payload) => {
  //iph todo: 47
  //console.log("GetTopUp", payload);
  return axios.post(B_URL + "TopUpModule/GetTopUp", payload, { headers });
};
const GetReviewData = (payload) => {
  //iph todo: 47
  //console.log("GetReviewData", payload);
  return axios.post(B_URL + "ReviewModule/GetReviewData", payload, { headers });
};

const GetOrdersProductForReview = (payload) => {
  //iph todo: 47
  //console.log("GetOrdersProductForReview", payload);
  return axios.post(B_URL + "OrderModule/GetOrdersProductForReview", payload, { headers });
};

const MyReviews = (payload) => {
  //iph todo: 47
  //console.log("MyReviews", payload);
  return axios.post(B_URL + "OrderModule/MyReviews", payload, { headers });
};

const AddReview = (payload) => {
  //iph todo: 47
  //console.log("AddReview", payload);
  return axios.post(B_URL + "OrderModule/AddReview", payload, { headers });
};

const GetRewards = (user_id) => {
  //iph todo: 47
  //console.log("user_id", user_id);

  var payload = {
    "functionName": "GetRewardsHistory",
    "postData": {
      "user_id": user_id
    }
  }

  return axios.post(B_URL + "RewardModule/GetRewardsHistory", payload, { headers });
};

const RedeemPoints = (data) => {
  //iph todo: 47
  //console.log("data", data);
  var payload = {
    "functionName": "RewardToPayment",
    "postData": {
      "points": data.points,
      "user_id": data.user_id
    }
  }

  return axios.post(B_URL + "RewardModule/RewardToPayment", payload, { headers });
};


const GetDashboardSummary = (sessionID, payload) => {
  //iph todo: 47
  //console.log("GetDashboardSummary:-", payload);
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/DashboardSummary", payload, { headers });
};


const uploadReceipt = (receipt, user_id, business_id) => {
  //iph todo: 47
  //console.log("user_id", user_id);

  var payload = {
    "functionName": "processInvoice",
    "postData": {
      "user_id": user_id,
      "receipt": receipt,
      "business_id": business_id
    }
  }

  return axios.post(B_URL + "E_InvoiceModule/processInvoice", payload, { headers });
};

const getAllItems = (payload) => {
  return axios.post(B_URL + 'ItemsRoutes/' + payload.functionName, payload, { headers });
};

const GetDropDownItems = (payload) => {
  return axios.post(B_URL + 'ItemsRoutes/' + payload.functionName, payload, { headers });
};

const saveRFQ = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/AddRFQ", payload, { headers });
};

const updateRFQ = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.put(B_URL + "RFQModule/updateRFQ", payload, { headers });
};

const ReturnRFQ = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.put(B_URL + "RFQModule/ReturnRFQ", payload, { headers });
};

const GetRFQs = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/GetRFQs", payload, { headers });
};


const GetBusinesses = (sessionID, payload) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "GetBusinesses",
    "postData": {
      "offset": 0,
      "sort": {
        "_id": -1
      },
      "limit": 9999999999,
      "business_ids": []
    }
  }
  return axios.post(B_URL + "BusinessModule/GetBusinesses", payload, { headers });
};

const GetRFQDetails = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/GetRFQDetails", payload, { headers });
};

const AcceptRFQ = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/AcceptRFQ", payload, { headers });
};

const AcceptReturnItems = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/AcceptReturnItems", payload, { headers });
};

const RejectRFQ = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/RejectRFQ", payload, { headers });
};

const GetUserOrders = (payload) => {
  return axios.post(B_URL + "OrderModule/GetUserOrders", payload, { headers });
};

const OnlinePayment = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  return axios.post(B_URL + "invoices", payload, { headers });
};

const getDashboardData = (_id, sessionID) => {
  let payload = {
    functionName: 'getDashboardData',
    postData: {
      _id: _id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'RFQModule/getDashboardData', payload, { headers });
};


const getAdminDashboardData = (sessionID, startDate, endDate) => {
  let payload = {
    functionName: 'getAdminDashboardData',
    postData: {
      startDate: startDate,
      endDate: endDate
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'RFQModule/getAdminDashboardData', payload, { headers });
};


const getAdminRevenueData = (Type, startDate, endDate, interval, sessionID) => {
  //iph todo: 47
  //console.log('Type', Type);
  let payload = {
    functionName: 'getAdminRevenueData',
    postData: {
      Type: Type,
      interval: interval,
      startDate: startDate,
      endDate: endDate
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'RFQModule/getAdminRevenueData', payload, { headers });
};

const MarkFav = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  return axios.post(B_URL + 'RFQModule/MarkFav', payload, { headers });
};

const getActiveBanners = (sessionID) => {
  let payload = {
    functionName: 'getActiveBanners',
    postData: {
      "type": "doctors_portal",
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + 'RFQModule/getActiveBanners', payload, { headers });
};

const addAddress = (addressData) => {
  var payload = {
    functionName: "AddAddress",
    postData: addressData,
  };
  return axios.post(B_URL + 'AddressModule/AddAddress', payload, { headers });
};

const GetAllDoctors = (payload) => {
  return axios.post(B_URL + 'UserModule/GetAllDoctors', payload, { headers });
};

const AddOrderByAdmin = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/AddOrderByAdmin", payload, { headers });
};
const AddQuotationByAdmin = (payload) => {
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "RFQModule/AddQuotationByAdmin", payload, { headers });
};

// Draft functionality
const SaveRFQDraft = (payload) => {
  //iph todo: 47
  //console.log("SaveRFQDraft payload", payload);
  return axios.post(B_URL + "RFQModule/SaveRFQDraft", payload, { headers });
};

const GetRFQDraft = (userId) => {
  return axios.get(B_URL + `RFQModule/GetRFQDraft/${userId}`, { headers });
};

const DeleteRFQDraft = (userId) => {
  return axios.delete(B_URL + `RFQModule/DeleteRFQDraft/${userId}`, { headers });
};
const GetStocks = (item_code) => {
  //iph todo: 47
  //console.log("item_id", item_code);
  let payload = {
    functionName: 'GetStocks',
    postData: {
      business_id: [],
      filterStatus: "",
      filterText: "",
      item_code:item_code,
      limit: 999999,
      offset: 0,
      sort: { _id: -1 }
    }
  }
  //iph todo: 47
  //console.log("payload", payload);
  return axios.post(B_URL + "StockModule/GetStocks", payload, { headers });
};


const DashboardService = {
  GetReviewData,
  MarkFav,
  AcceptRFQ,
  GetStocks,
  addAddress,
  AddOrderByAdmin,
  AddQuotationByAdmin,
  SaveRFQDraft,
  GetRFQDraft,
  DeleteRFQDraft,
  AcceptReturnItems,
  GetDropDownItems,
  getActiveBanners,
  getDashboardData,
  getAdminRevenueData,
  getAdminDashboardData,
  RejectRFQ,
  ReturnRFQ,
  OnlinePayment,
  getUserInvoices,
  GetRFQDetails,
  getAll,
  GetRFQCategories,
  GetBusinesses,
  GetRFQs,
  GetAllDoctors,
  getAllItems,
  saveRFQ,
  updateRFQ,
  GetUserOrders,
  GetOrdersProductForReview,
  MyReviews,
  getInvoices,
  Get_User_Invoices,
  AddReview,
  AddTopUp,
  GetTopUp,
  uploadReceipt,
  PlaceOrder,
  DeleteCart,
  GetDashboardData,
  getAllBusiness,
  getAllCategories,
  getAllStatements,
  getAllProducts,
  GetCartList,
  GetProducctDetails,
  GeProductReviews,
  setCart,
  GetRewards,
  RedeemPoints,
  GetDashboardSummary

};

export default DashboardService;